import { takeLatest, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/promocionesReducer/actions'
import * as Notifications from '../../components/Common/notification'

import * as layoutActions from '../../reducers/layoutReducer/actions'

function* genGetPromociones(e){
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Obteniendo promociones' }))
        // llamo a la acción que trae los rubros
        let promos = yield calls.getPromociones(e.id)
        if (e.id)
        yield put(reducerActions.savePromocionEdit(promos[0]))
        else
        yield put(reducerActions.savePromociones(promos))
    }
    catch (error) // error handle
    {if (error.Message) { Notifications.showError("Error al recuperar las promociones del servidor");return;}}
    finally{ yield put(layoutActions.setLoading({ show: false}))}//finalmente siempre saca la barra de loading
}

function* genSavePromo(e){
    try {

        // llamo a la acción que guarda el catálogo
        yield calls.savePromo(e.payload)
        if(e.payload.id !== null)
        Notifications.showSuccess("Promoción actualizada")
        else
        Notifications.showSuccess("Promoción creada")
        
        window.history.back();

    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
}

function* genSaveImagen(e){
    try {

        yield put(layoutActions.setLoading({ show: true, message: 'Sincronizando imagen promociones' }))
        // llamo a la acción que guarda el catálogo
        yield calls.saveImagen(e.payload)
        if (e.payload.currentFile === undefined){ 
            yield put(reducerActions.saveImagenPromociones([null, null])) 
            Notifications.showSuccess("Imagen de promoción eliminada.")
        }
        else{
            Notifications.showSuccess("Imagen de promoción sincronizada.")
        }
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally{
        yield put(layoutActions.setLoading({ show: false}))
        yield put(reducerActions.sagaImagenPromociones()) 
    }
}

function* genGetImagen(e){
    try {

        yield put(layoutActions.setLoading({ show: true, message: 'Obteniendo imagen promociones' }))
        // llamo a la acción que guarda el catálogo
        let i = []
        i[0] = yield calls.getImagen(false)
        i[1] = yield calls.getImagen(true)
        yield put(reducerActions.saveImagenPromociones(i))
        if(i[0]===""){Notifications.showInfo("No existe imagen de promociones")}
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally{
        
        yield put(layoutActions.setLoading({ show: false}))
    }
}


function* genEliminarPromocion(e){
    try {

        // llamo a la acción que guarda el catálogo
        yield calls.eliminarPromocion(e.id)
        
        Notifications.showSuccess("Promoción eliminada.")
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
}

function* defaultSaga() {
    yield all([      
        takeLatest(reducerActions.SAGA_GET_PROMOCIONES, genGetPromociones),
        takeLatest(reducerActions.GET_PROMOCION_EDIT, genGetPromociones),
        takeLatest(reducerActions.SAGA_SAVE_PROMOCIONES, genSavePromo),
        takeLatest(reducerActions.SAGA_SAVE_IMAGEN_PROMOCIONES, genSaveImagen),
        takeLatest(reducerActions.SAGA_ELIMINAR_IMAGEN_PROMOCIONES, genSaveImagen),
        takeLatest(reducerActions.SAGA_IMAGEN_PROMOCIONES, genGetImagen),
        takeLatest(reducerActions.SAGA_ELIMINAR_PROMOCIONES, genEliminarPromocion),

    ])
  }
  
  export const sagas = [
    defaultSaga
  ]